<template src="./index.html"></template>
<script>
	import {
		getdata
	} from './data.js';
	import {
		companyuserinfopage,
		templatepage,
		noticeindexpage,
		userpage,
		userGroupsave,
		grouppage,
		companyuserinfosave,
		indexExgetOne,
		groupdelete,
		companyuserinfodelete,
		noticetemplate,
		fetchGroupUser,
		fxjk_comapny,
		
	} from '../../../../api/Notificationsettings.js';
	import 'quill/dist/quill.core.css';
	import 'quill/dist/quill.snow.css';
	import 'quill/dist/quill.bubble.css';
	import {
		quillEditor
	} from 'vue-quill-editor';
	export default {
		name: 'tzsz',
		components: {
			quillEditor
		},
		data: function() {
			return {
				//查询
				pagination: getdata().pagination,
				tableData: getdata().tableData,
				headData: getdata().headData,
				//新建通知
				inputlist: {
					cjzm: '',
					tzss: '',
					input: '',
					tzmc: '',
					groupId: '',
					id: null,
					isshow: false,
					companyId:"",
					eventType:[]
				},
				tableDataleft: [],
				headDataleft: getdata().headDataleft,
				tableDataright: [],
				headDataright: getdata().headDataright,
				dialogVisible: false,
				//创建通知组
				search: '',
				tableDatatz: [],
				Createtzdiag: false,
				headDataCreate: getdata().headDataCreate,
				tableDataCreate: [],
				groupIdList: [],
				//
				
				content: '',
				sfqy: '',
				name: '',
				radios: null,
				shaidiag: true,
				sjlydiag: false,
				paginationtzz: getdata().paginationtzz,
				ruleForm: {
					test1: '',
					test2: '',
					test3: '',
					test4: '',
					test5: ''
				},
				options: getdata().options,
				value: '',
				mValue: '',
				elSelect: [],
				glData: [{}, {}],
				
				radio: '1',
				rabios: null,
				glzb_nsrmc: '',
				tzdiag: false,
				headDatatz: getdata().headDatatz,
			
				headDatazb: getdata().headDatazb,
				tableDatazb: [],
				zbdiag: false,
				tablekey: 0,
				title: '',
				chooseindex: 0,
				overlength: 0,
				disableds: false,
				lrdetail: false,
				editorOption: {
					modules: {
						toolbar: [
							['bold', 'italic', 'underline', 'strike', 'link', 'image',
							'code-block'], // toggled buttons
							[{
								align: []
							}], //对齐方式
							[{
								header: [1, 2, 3, 4, 5, 6, false]
							}], //几级标题
							[{
								font: []
							}], //字体
							[{
								size: ['small', 'normal', 'large', 'huge']
							}],
							[{
									color: []
								},
								{
									background: []
								}
							] // 字体颜色，字体背景颜色
						]
					}
				},
				listset: {
					one: [],
					out: [],
					three: []
				},
				suosq: this.$getdefultMonth(),
				ouglist: [],
				
				idsss: false,
			};
		},
		created() {},
		mounted() {
			this.updatalist();
			fxjk_comapny().then(res => {
				if (res.data.code == 1) {
					this.elSelect = res.data.data.map(item => {
						return {
							value: item.id,
							label: item.nsrmc
						};
					});
				}
			});
		},
		methods: {
			//查询
			updatalist() {
				let params = {
					size: this.pagination.pageSize,
					current: this.pagination.pageNum,
				};
				companyuserinfopage(params).then(res => {
					if (res.data.code == 1) {
						this.tableData = res.data.data.records;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			currentChange(e) {
				this.pagination.pageNum = e;
			},
			sizechange(e) {
				this.pagination.pageSize = e;
			},
			//新建通知
			uptz() {
				Object.keys(this.inputlist).map(key => {
					this.inputlist[key] = '';
				});
				this.inputlist.tzmc = '';
				this.inputlist.isshow = false;
				this.title = '新建通知';
				this.tableDataright = [];
				this.group();
			},
			group() {
				let params = {
					size: 10000000,
					current: this.paginationtzz.pageNum,
					groupName: this.search
				};
				grouppage(params).then(res => {
					if (res.data.code == 1) {
						this.dialogVisible = true;
						this.tableDataleft = res.data.data.records;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			//创建通知组
			nexttz() {
				let list = this.$refs.grouplist.getSelectionval();
				let deleteList = [];
				this.tableDataCreate.map(item => {
					let num = 0;
					if (list.length == 0) {
						deleteList.push(item);
					} else {
						list.map((item1, index) => {
							if (item.id == item1.id) {
								num++;
							} else if (item.id != item1.id && index == list.length - 1 && num == 0) {
								deleteList.push(item);
							}
						});
					}
				});
				list.map(item => {
					this.groupIdList.push(Number(item.id));
				});
				let a = Array.from(new Set(this.groupIdList));
				this.groupIdList = a;
				deleteList.map(item => {
					this.groupIdList.map((item1, index) => {
						if (item.id == item1) {
							this.groupIdList.splice(index, 1);
						}
					});
				});
				if (this.inputlist.cjzm != '') {
					for (let a = 0; a < this.groupIdList.length; a++) {
						this.listset.one.push(this.groupIdList[a]);
					}
					let params = {
						userIdArr: this.listset.one,
						groupName: this.inputlist.cjzm
					};
					if (this.inputlist.groupId != '') {
						params.groupId = this.inputlist.groupId;
					}
					userGroupsave(params).then(res => {
						if (res.data.code == 1) {
							this.Createtzdiag = false;
							this.$message.success('新增成功');
							this.paginationtzz.pageNum = 1;
							this.inputlist.cjzm = '';
							this.group();
						} else {
							this.$message.error(res.data.msg);
						}
					});
				} else {
					this.$message.error('组名称不能为空');
				}
			},
			savegroup() {
				this.inputlist.groupId = '';
				this.inputlist.cjzm = '';
				this.Createtzdiag = true;
				this.groupIdList = [];
				this.$nextTick(() => {
					this.$refs.grouplist.toggleSelection([]);
				});
				this.user();
			},
			user() {
				let params = {
					size: this.paginationtzz.pageSize,
					current: this.paginationtzz.pageNum,
					username: this.search
				};
				userpage(params).then(res => {
					if (res.data.code == 1) {
						this.tableDataCreate = res.data.data.records;
						this.paginationtzz.total = parseFloat(res.data.data.total);
						let list = [];
						this.tableDataCreate.map(item => {
							this.groupIdList.map(item1 => {
								if (item.id == item1) {
									list.push(item);
								}
							});
						});
			
						this.$nextTick(() => {
							this.$refs.grouplist.toggleSelection(list);
						});
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			//编辑通知组
			tzdiags(e) {
				this.Createtzdiag = true;
				this.inputlist.groupId = e.id;
				this.edit();
				this.inputlist.cjzm = e.groupName;
			},
			edit(e) {
				this.paginationtzz.pageNum = 1;
				this.paginationtzz.paginationkey++;
				if (this.Createtzdiag == true) {
					this.search = this.inputlist.tzss;
					if (!e) {
						let groupId = this.inputlist.groupId;
						fetchGroupUser({
							groupId: this.inputlist.groupId
						}).then(res => {
							if (res.data.code == 1) {
								let a = Array.from(new Set(res.data.data));
								this.groupIdList = a;
								this.tzdx();
							} else {
								this.$message.error(res.data.msg);
							}
						});
					} else {
						this.tzdx();
					}
				} else if (this.tzdiag == true) {
					this.search = this.inputlist.mbss;
					this.mbpage();
				} else if (this.dialogVisible) {
					this.search = this.inputlist.input;
					this.group();
				} else {
					this.uptz();
				}
			},
			//删除通知组
			deletes(e) {
				this.$showConfirm({
					message: '确认删除?'
				}).then(res => {
					if (res == 'confirm') {
						let params = {
							id: e.id
						};
						groupdelete(params).then(res => {
							if (res.data.code == 1) {
								this.$message.success('删除成功');
								this.group();
							} else {
								this.$message.error(res.data.code);
							}
						});
					}
				});
			},
			//删除列表数据
			deluplist() {
				let ids = this.$refs.tableboxs.getSelectionval();
				if (ids.length == 0 || ids.length > 1) {
					return this.$message.error('请选择你要删除的数据,有且只能有一条');
				}
				this.$showConfirm({
					message: '确认删除?'
				}).then(res => {
					if (res == 'confirm') {
						let id = [];
						ids.map(item => {
							id.push(item.id);
						});
						companyuserinfodelete(id).then(res => {
							if (res.data.code == 1) {
								this.$message.success('删除成功');
								this.updatalist();
							} else {
								this.$message.error(res.data.code);
							}
						});
					}
				});
			},
			//通知组左右移动
			left() {
				let listup = this.$refs.tableright.getSelectionval();
				listup.map(item => {
					for (let a = 0; a < this.tableDataright.length; a++) {
						if (item.id == this.tableDataright[a].id) {
							this.tableDataright.splice(a, 1);
						}
					}
					this.tableDataleft.push(item);
				});
			},
			right() {
				let listup = this.$refs.tableleft.getSelectionval();
				listup.map(item => {
					for (let a = 0; a < this.tableDataleft.length; a++) {
						if (item.id == this.tableDataleft[a].id) {
							this.tableDataleft.splice(a, 1);
						}
					}
					console.log(this.tableDataright)
					this.tableDataright.push(item);
				});
			},
			delsget(e, i) {
				let params = {
					id: e.id
				};
				Object.keys(this.inputlist).map(key => {
					this.inputlist[key] = '';
				});
				this.search = '';
				if (i == 1) {
					this.inputlist.isshow = true;
				} else {
					this.inputlist.isshow = false;
				}
				let datas = JSON.parse(JSON.stringify(e));
				this.inputlist.id = datas.id;
				this.inputlist.tzmc = datas.noticeMc;
				this.inputlist.mbname = {
					noticeTemplateName: datas.noticeTemplateName,
					id: datas.noticeTemplateId
				};
				this.radio = datas.relationRisk;
				this.inputlist.time = datas.noticeStopTime;
				this.glData = datas.risks;
				this.ouglist = datas.risks;
				let param = {
					size: 1000000000,
					current: this.paginationtzz.pageNum,
					groupName: this.search
				};
				grouppage(param).then(res => {
					if (res.data.code == 1) {
						this.dialogVisible = true;
						this.tableDataleft = res.data.data.records;
						this.tableDataright=this.tableDataleft.filter(item=>datas.groupId.includes(item.id))
					} else {
						this.$message.error(res.data.msg);
					}
				});

			},
			mbpage() {
				if (this.inputlist.mbname.id) {
					this.radios = this.inputlist.mbname.id;
				}
				let params = {
					size: this.paginationtzz.pageSize,
					current: this.paginationtzz.pageNum,
					noticeTemplateName: this.search
				};
				templatepage(params).then(res => {
					if (res.data.code == 1) {
						this.paginationtzz.total = parseFloat(res.data.data.total);
						this.tableDatatz = res.data.data.records;
						this.tzdiag = true;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			nextxz() {
				if (this.inputlist.tzmc == '') {
					return this.$message.error('名称不能为空');
				}
				
				this.title = '编辑通知';
				if(this.tableDataright.length>1){
					return this.$message.error('只能选择一个通知组');
				}
				let groupIds = [];
				let {
					time,
					mbname,
					tzmc,
					id,
					companyId,
					eventType
				} = this.inputlist;
				if(this.tableDataright.length>0){
					this.tableDataright.map(item => {
						groupIds.push(item.id);
					});
				}
				
				let params = {
					groupId: groupIds[0],
					noticeMc: tzmc,
					noticeStopTime: time,
					noticeTemplateId: mbname.id || '',
					noticeTime: this.value,
					relationRisk: this.radio,
					companyId:companyId,
					eventType:eventType
				};
				if (id != null && id != '') {
					params.id = id;
				}
				companyuserinfosave(params).then(res => {
					if (res.data.code == 1) {
						this.dialogVisible = false;
						if (params.id) {
							this.$message.success('编辑成功');
						} else {
							this.$message.success('新建成功');
						}
						this.updatalist();
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			tzdx() {
				this.paginationtzz.pageNum = '1';
				this.listset.one = [];
				// this.inputlist.cjzm = ''
				this.user();
			},
			zdzb() {
				let params = {
					size: this.paginationtzz.pageSize,
					current: this.paginationtzz.pageNum,
					suosq: this.suosq,
					companyCode: this.glzb_nsrmc,
				};
				noticeindexpage(params).then(res => {
					if (res.data.code == 1) {
						this.zbdiag = true;
						this.paginationtzz.total = parseFloat(res.data.data.total);
						this.tableDatazb = res.data.data.records;
						let list = [];
						this.ouglist.map(item => {
							let num = 0;
							this.tableDatazb.map((item1, index1) => {
								if (item.id == item1.id) {
									list.push(item1);
									num = 1;
								}
							});
						});
						this.$nextTick(() => {
							this.$refs.zbtable.toggleSelection(list);
						});
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			currentChangetz(e) {
				this.paginationtzz.pageNum = e;
				if (this.Createtzdiag == true) {
					let list = this.$refs.grouplist.getSelectionval();
					let deleteList = [];
					this.tableDataCreate.map(item => {
						let num = 0;
						if (list.length == 0) {
							deleteList.push(item);
						} else {
							list.map((item1, index) => {
								if (item.id == item1.id) {
									num++;
								} else if (item.id != item1.id && index == list.length - 1 && num == 0) {
									deleteList.push(item);
								}
							});
						}
					});
					list.map((item1, index) => {
						this.groupIdList.push(Number(item1.id));
					});
					let a = Array.from(new Set(this.groupIdList));
					this.groupIdList = a;
					deleteList.map(item => {
						this.groupIdList.map((item1, index) => {
							if (item.id == item1) {
								this.groupIdList.splice(index, 1);
							}
						});
					});
					this.user();
				} 
			},
			sizechangetz(e) {
				this.paginationtzz.pageSize = e;
				if (this.Createtzdiag) {
					this.tzdx();
				} else if (this.zbdiag) {
					this.zdzb();
				}
			},
			
		
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
</style>